import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ backgroundColor: 'oklch(var(--background-100))' }}>
      <div className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-gradient-to-br from-primary-500 to-accent-500 rounded-lg">
                <i className="ri-movie-2-fill text-lg" style={{ color: 'oklch(var(--background-50))' }}></i>
              </div>
              <span className="text-lg font-bold font-heading" style={{ color: 'oklch(var(--foreground-950))' }}>黄瓜影视</span>
            </div>
            <p className="text-sm leading-relaxed" style={{ color: 'oklch(var(--foreground-500))' }}>
              黄瓜影视在线看，海量高清影视资源免费畅享，涵盖热门电影、电视剧、综艺、动漫等全类型内容，随时随地开启你的追剧体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4" style={{ color: 'oklch(var(--foreground-800))' }}>快速导航</h4>
            <div className="space-y-2.5">
              <Link to="/" className="block text-sm hover:text-primary-500 transition-colors" style={{ color: 'oklch(var(--foreground-500))' }}>首页</Link>
              {categories.map(cat => (
                <Link key={cat.slug} to={`/category/${cat.slug}`} className="block text-sm hover:text-primary-500 transition-colors" style={{ color: 'oklch(var(--foreground-500))' }}>
                  {cat.label}
                </Link>
              ))}
              <Link to="/about" className="block text-sm hover:text-primary-500 transition-colors" style={{ color: 'oklch(var(--foreground-500))' }}>关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4" style={{ color: 'oklch(var(--foreground-800))' }}>热门推荐</h4>
            <div className="space-y-2.5">
              <Link to="/article/movie-001" className="block text-sm hover:text-primary-500 transition-colors" style={{ color: 'oklch(var(--foreground-500))' }}>流浪地球3</Link>
              <Link to="/article/tv-002" className="block text-sm hover:text-primary-500 transition-colors" style={{ color: 'oklch(var(--foreground-500))' }}>庆余年第二季</Link>
              <Link to="/article/movie-005" className="block text-sm hover:text-primary-500 transition-colors" style={{ color: 'oklch(var(--foreground-500))' }}>热辣滚烫</Link>
              <Link to="/article/anime-001" className="block text-sm hover:text-primary-500 transition-colors" style={{ color: 'oklch(var(--foreground-500))' }}>哪吒之魔童降世</Link>
              <Link to="/article/variety-001" className="block text-sm hover:text-primary-500 transition-colors" style={{ color: 'oklch(var(--foreground-500))' }}>奔跑吧·第12季</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4" style={{ color: 'oklch(var(--foreground-800))' }}>联系我们</h4>
            <div className="space-y-2.5">
              <p className="text-sm" style={{ color: 'oklch(var(--foreground-500))' }}>
                <i className="ri-mail-line mr-2"></i>contact@huanggua.tv
              </p>
              <p className="text-sm" style={{ color: 'oklch(var(--foreground-500))' }}>
                <i className="ri-phone-line mr-2"></i>400-888-6666
              </p>
              <p className="text-sm" style={{ color: 'oklch(var(--foreground-500))' }}>
                <i className="ri-map-pin-line mr-2"></i>北京市朝阳区建国路88号
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t text-center" style={{ borderColor: 'oklch(var(--foreground-50)/0.06)' }}>
          <p className="text-xs" style={{ color: 'oklch(var(--foreground-400))' }}>
            &copy; {currentYear} 黄瓜影视在线看 huanggua.tv 版权所有 | 本站所有内容均来自正版授权合作方
          </p>
        </div>
      </div>
    </footer>
  );
}